import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";
import BgImg from "../../images/location_new/miami/near_miami_back.webp";
import { Link } from "gatsby";

function Dynamichouston() {
  return (
    <section
      className="dynamic_houston p-100"
      style={{
        backgroundImage: `url(${BgImg})`,
      }}
    >
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto resp_order"
          >
            <StaticImage
              src="../../images/location_new/miami/near_miami.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={486}
              height={651}
            />
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <h2>The Best Mobile App Development Services in Miami Near You</h2>
            <p>
              Are you looking for the best Miami app development company near
              me? TekRevol is here to answer all of your development needs! As a
              leading app development company in Miami, we take the
              responsibility of bridging the gap between innovation and
              usability – giving you an ever-lasting experience. We ensure that
              businesses can get the kind of apps that not just meet their
              business goals but also serve as benchmarks for the industry to
              follow. Now, you can avail the services of one of the leading
              software and app development companies in Florida near you.
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book A Consultation Now!
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Dynamichouston;
